import { TranslateService } from "./../../shared/translate/translate.service";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import {
  PersonModel,
  EmailAddressModel,
  PersonAddressModel
} from "../models/person.model";
import { PersonService } from "../models/person.service";
import { InstanceService } from "../../instance/models/instance.service";
import { Router, ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  WeGoConfig,
  Permission,
  PermissionType,
  RoleLevel
} from "../../shared/config";
import { OrganizationService } from "../../organization/models/organization.service";
import { FlatPickrDirective } from "./../../plugins/flatpickr/flatpickr.directive";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import { DropdownModel } from "../../report/models/report-filter.model";
import * as buffer from "buffer";

@Component({
  selector: "wego-perosn",
  template: require('../views/person-update.component.html'),
  providers: [PersonService, InstanceService, OrganizationService],
  styles: [
    `
    .personRole {
      display: inline;
    }
    .input-group.telephone-group .input-group-addon {
      padding: 0px;
      border: 0px;
    }
    .country-select {
      width: 60px;
      border: 1px solid #d2d6de;
      padding: 3px;
    }
  `
  ]
})
export class PersonUpdateComponent implements OnInit, OnDestroy {
  personHashId: string;
  sub: any;
  apiResponse: IAPIResponse;
  model: PersonModel;
  submitModel: PersonModel;
  instanceList: DropdownModel[];
  countryList: DropdownModel[];
  personCountryList: DropdownModel[];
  errorModel: IKeyValueInterface[];
  message: string;
  errorMessage: string;
  urlDriverList: string;
  isEditMode: boolean;
  licenseTypes: any;
  preferredlanguage: any;
  debtornr: string;
  licenseTypeArray: string[];
  certificates: string;
  urlDefaultPage: string;
  urlPersonList: string;
  selectedInstance: string = "";
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  organizationList: any;
  flatPickrConfigFrom: FlatPickrModel;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  roleLevel = RoleLevel;

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild("flatPickrConfigFromDate")
  public flatPickrConfigFromDate: FlatPickrDirective;
  public fixRfidMsg: string;

  constructor(
    private organizationService: OrganizationService,
    private personService: PersonService,
    private instanceService: InstanceService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private locationService: Location
  ) { }

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlPersonList = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_LIST
    );
    this.urlDriverList = this.authService.GetURL(
      ApplicationRouteURL.URL_DRIVER_LIST
    );
    this.licenseTypeArray = [];
    this.module = this.translate.instant("LblPerson");
    this.model = new PersonModel();
    this.model.organizationHashId = "";
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();

    this.licenseTypes = [
      {
        Key: "AM",
        Value: "AM",
        IsChecked: false
      },
      {
        Key: "A",
        Value: "A",
        IsChecked: false
      },
      {
        Key: "B",
        Value: "B",
        IsChecked: false
      },
      {
        Key: "C",
        Value: "C",
        IsChecked: false
      },
      {
        Key: "C1",
        Value: "C1",
        IsChecked: false
      },
      {
        Key: "D",
        Value: "D",
        IsChecked: false
      },
      {
        Key: "T",
        Value: "T",
        IsChecked: false
      }
    ];

    

    this.preferredlanguage = [
      {
        Key: "English",
        Value: "en_US"
      },
      {
        Key: "French",
        Value: "fr_FR"
      },
      {
        Key: "Dutch",
        Value: "nl_NL"
      },
      {
        Key: "German",
        Value: "de_DE"
      },
      {
        Key: "Polish",
        Value: "pl_PL"
      },
      {
        Key: "Spanish",
        Value: "es_ES"
      }
    ];
    
    this.GetTelephoneCountry();
    this.GerPersonDetail();
    this.GetPersonCountry();

    
  }

  public GetTelephoneCountry() {
    this.authService.GetTelephoneCountry()
      .subscribe(
        res => {
          this.countryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }


  public OnChangeLicenseType(licenseType: any, isChecked: any) {
    var objIndex = this.licenseTypes.findIndex(
      (x: any) => x.Value == licenseType.Value
    );
    if (isChecked) {
      this.licenseTypeArray.push(licenseType.Value);
    } else {
      var index = this.licenseTypeArray.indexOf(licenseType.Value);
      if (index > -1) {
        this.licenseTypeArray.splice(index, 1);
      }
    }
    this.licenseTypes[objIndex].IsChecked = isChecked;
  }

  public SetDriverLicenseOnEdit() {
    if (this.model.licenseTypes != null && this.model.licenseTypes.length > 0) {      
      var LicenseArray = this.model.licenseTypes.split(",");
      for (let i = 0; i < LicenseArray.length; i++) {
        var objIndex = this.licenseTypes.findIndex(
          (x: any) => x.Value == LicenseArray[i]
        );
        this.licenseTypes[objIndex].IsChecked = true;
        this.licenseTypeArray.push(this.licenseTypes[objIndex].Value);
      }
    }
  }

  public JoinAllDriverLicenses() {
    if (this.licenseTypeArray != null && this.licenseTypeArray.length > 0)
      this.model.licenseTypes = this.licenseTypeArray.join(",");
    else this.model.licenseTypes = "";
  }

  public GetPersonCountry() {
    this.authService.GetPersonCountry()
      .subscribe(
        res => {
          this.personCountryList = res.data;
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GerPersonDetail() {
    this.sub = this.activeRoute.params.subscribe(params => {
      this.isEditMode = false;
      

      this.personHashId = params["id"] || "";
      if (this.personHashId != "") {
        this.isEditMode = true; 
        this.personService.GetPersonByHashId(this.personHashId).subscribe(
          res => {
            this.model = res.data;
            this.GetInstanceList();
            if (
              this.model != null &&
              this.model.licenseTypes != null
            ) {
              this.SetDriverLicenseOnEdit();
            }
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );
      } else {
        this.model.preferredlanguage =
          this.preferredlanguage.length > 0
            ? this.preferredlanguage[0].Value
            : "";
        this.GetInstanceList();
      }
    });
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  private SetDefaultFlatPickrConfig(isDateOnly?: boolean) {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = !isDateOnly ? true : false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    flatPickrConfig.maxDate = new Date();
    return flatPickrConfig;
  }

  onSubmit(forms: any) {
    this.AddNewPerson();
  }

  public GetInstanceList() {
    let permissionType = "";
    if (this.isEditMode) {
      permissionType = PermissionType.EDIT;
    } else {
      permissionType = PermissionType.INSERT;
    }

    this.instanceService
      .GetInstanceListDropdownForAddUpdatePage("person", permissionType)
      .subscribe(
        res => {
          this.apiResponse = res;
          this.instanceList = res.data;
          if (this.instanceList.length == 1) {
            //this.model.instanceId = this.instanceList[0].;
            this.model.instanceHashId = this.instanceList[0].keyHash;
            this.InstanceUpdate();
          }
        },
        error => {
          this.errorMessage = this.authService.HandleErrorStatusCode(error);
        }
        // () => this.GetOrganizationList()
      );
  }

  // public GetOrganizationList() {
  //   this.organizationService.GetOrganizationList()
  //     .subscribe(
  //     res => {
  //       this.organizationList = res.data;
  //       if (this.organizationList.length == 1) {
  //         this.model.organizationHashId = this.organizationList[0].organizationMasterHashId;
  //       }
  //     },
  //     error => {
  //       this.errorMessage = this.authService.HandleErrorStatusCode(error);
  //     },
  //     () => this.GerPersonDetail()
  //     );
  // }

  public InstanceUpdate() {
    if (this.model.instanceHashId) {
      this.instanceService
        .IsNIFNumberEnabled(this.model.instanceHashId)
        .subscribe(
          res => {
            this.apiResponse = res;
            let nifNumberEnabled: boolean = res.data;
            if (nifNumberEnabled) {
              this.model.isnifEnabled = true;
            } else {
              this.model.isnifEnabled = false;
            }
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );

      this.instanceService
        .GetCountryCode(this.model.instanceHashId)
        .subscribe(
          res => {
            this.apiResponse = res;
            let countryCode: string = res.data;

            if (countryCode) {
              this.model.countryCode1 = countryCode;
              this.model.countryCode2 = countryCode;
            }
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );

      this.instanceService
        .IsDirectDebitEnabled(this.model.instanceHashId)
        .subscribe(
          res => {
            this.apiResponse = res;
            let directDebitEnabled: boolean = res.data;
            if(!this.personHashId)
            {
              if (directDebitEnabled) {
                this.model.directDebitFileEnabledOnInstance = true;
                this.model.subjectToDirectDebit = true;
              } else {
                this.model.directDebitFileEnabledOnInstance = false;
                this.model.subjectToDirectDebit = false;
              }
            }            
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );

      this.instanceService
        .IsTwoFaEnabled(this.model.instanceHashId)
        .subscribe(
          res => {
            this.model.isInstanceTwofaEnabled = res.data;;
          },
          error => {
            this.errorMessage = this.authService.HandleErrorStatusCode(error);
          }
        );

    }
  }

  public AddNewPerson() {
    this.JoinAllDriverLicenses();
    this.personService.AddPerson(this.model).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.isEditMode
            ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
            : this.translate.instant("LblRecordAddedSuccess", [this.module]);
          this.ShowSuccessPopup();
        } else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  fixRfid() {
    if (this.model.rfidTagId) {
      var tag = this.model.rfidTagId.toUpperCase();
      this.CorrectTag(tag);
    }
  }

  public CorrectTag(rfidTagId: string) {
    this.personService.CorrectTag(rfidTagId)
      .subscribe(
        res => {
          this.fixRfidMsg = "";
          if (res.data && !res.error) {            
            this.model.rfidTagId = res.data;
          }
          else {
            this.fixRfidMsg = res.error[0].value;
          }
        },
        error => {
          this.fixRfidMsg = this.authService.HandleErrorStatusCode(error);
        }
      );  
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/person/components/person-update.component.ts